'use strict'

$(function () {
	var index = {
		init: function init() {
			this.video()
			this.yuyue()
			this.swiper()
			this.book()
			$('.zixun').click(function () {
				$('.toumingbi_yspd').show()
				$('.leyu_yspd').show()
			})
			$('.close_ly').click(function () {
				$('.toumingbi_yspd').hide()
				$('.leyu_yspd').hide()
			})

			$('.choose_btn_list').click(function () {
				var top1 = $('.course').offset().top
				$('html,body').animate({
					scrollTop: top1,
				})
			})
		},

		video() {
			TCPlayer('videoPlayerA', {
				fileID: '3701925921004751635',
				appID: '1259605108',
				autoplay: false,
			})
			TCPlayer('videoPlayerB', {
				fileID: '5285890793928536056',
				appID: '1259605108',
				autoplay: false,
			})
			TCPlayer('videoPlayerC', {
				fileID: '5285890794347649685',
				appID: '1259605108',
				autoplay: false,
			})
		},

		swiper() {
			new Swiper('.keep_container', {
				loop: true,
				autoplay: {
					delay: 3000,
				},
				speed: 1000,
				navigation: {
					nextEl: '.keep_next',
					prevEl: '.keep_prev',
				},
			})
		},
		yuyue() {
			$('.ad .kuang_city .current').click(function () {
				$('.ad .kuang_city .list').show()
			})
			$('.ad .kuang_city .option').click(function () {
				var _this = $(this)
				$('.ad .kuang_city .current').text(_this.text())
				$('.ad .hidden_city').val(_this.text())
				$('.ad .kuang_city .list').hide()
			})

			const queryObj = {
				'': 'PC秋季班在线报名',
				'?jtppzq': 'PC秋季班在线报名（百品）',
				'?360jtppzq': 'PC秋季班在线报名（360）',
			}
			const query = window.location.search
			new Reservation('#form1', {
				siteId: 3, // 站点ID
				contentName: queryObj[query], // 预约名称
			})

			$('.study .kuang_city .current').click(function () {
				$('.study .kuang_city .list').show()
			})
			$('.study .kuang_city .option').click(function () {
				var _this = $(this)
				$('.study .kuang_city .current').text(_this.text())
				$('.study .hidden_city').val(_this.text())
				$('.study .kuang_city .list').hide()
			})
			const bmObj = {
				'': 'PC秋季班领取资料',
				'?jtppzq': 'PC秋季班领取资料（百品）',
				'?360jtppzq': 'PC秋季班领取资料（360）',
			}
			const bmQuery = window.location.search
			new Reservation('#form2', {
				siteId: 3, // 站点ID
				contentName: bmObj[bmQuery], // 预约名称
			})

			// 立即报名
			$('.form .kuang_city .current').click(function () {
				$('.form .kuang_city .list').show()
			})
			$('.form .kuang_city .option').click(function () {
				var _this = $(this)
				$('.form .kuang_city .current').text(_this.text())
				$('.form .city03').val(_this.text())
				$('.form .kuang_city .list').hide()
			})
			const lqObj = {
				'': 'PC秋季班底部浮窗',
				'?jtppzq': 'PC秋季班底部浮窗（百品）',
				'?360jtppzq': 'PC秋季班底部浮窗（360）',
			}
			const lqQuery = window.location.search
			new Reservation('#form3', {
				siteId: 3, // 站点ID
				contentName: lqObj[lqQuery], // 预约名称
			})
		},
		book: function book() {
			$('.book_navItem').click(function () {
				$(this).addClass('cur').siblings().removeClass('cur')
				$('.book_txtItem').eq($(this).index()).show().siblings().hide()
				$('.book_contentList').eq($(this).index()).show().siblings().hide()
				new Swiper('.book_container', {
					autoplay: {
						delay: 2000,
						disableOnInteraction: true,
					},
					loop: true,
					effect: 'coverflow',
					slidesPerView: 2.8,
					centeredSlides: true,
					coverflowEffect: {
						rotate: 0,
						stretch: -36,
						depth: 120,
						modifier: 3,
						slideShadows: false,
					},
					navigation: {
						nextEl: '.book_next',
						prevEl: '.book_prev',
					},
				})
			})
			new Swiper('.book_container', {
				autoplay: {
					delay: 2000,
					disableOnInteraction: true,
				},
				loop: true,
				effect: 'coverflow',
				slidesPerView: 2.8,
				centeredSlides: true,
				coverflowEffect: {
					rotate: 0,
					stretch: -36,
					depth: 120,
					modifier: 3,
					slideShadows: false,
				},
				navigation: {
					nextEl: '.book_next',
					prevEl: '.book_prev',
				},
			})
		},
	}
	index.init()
})
//# sourceMappingURL=map/index.js.map
